module.exports = __webpack_public_path__ + "img/26_136.f0cb1520.png";